<template>
    <readout-group-list
        :abstract-schema-config="schemaConfig"
        :readout-groups="readoutGroups"
        @create="createReadoutGroup"
        @update="updateReadoutGroup"
        @delete="deleteReadoutGroup"
    />
</template>
<script setup lang="ts">

import { ReadoutGroup, readoutGroupsAPI, SavedReadoutGroup } from "@/services/readoutGroups/readoutGroupsAPI";
import { SchemaConfigAdminConfig } from "@/services/schemas/manageSchemasAPI";
import { withLoadingScreen } from "@/lib/loading";
import ReadoutGroupList from "@/components/Measurements/ReadoutGroupList.vue";

const { schemaConfig, readoutGroups } = defineProps<{
    schemaConfig: SchemaConfigAdminConfig
    readoutGroups: SavedReadoutGroup[]
}>();

const emit = defineEmits<{
    (e: "saved");
    (e: "deleted");
}>()

async function createReadoutGroup(readoutGroup: ReadoutGroup) {
    return save(() => readoutGroupsAPI.bySchemaConfig(schemaConfig.id).create(readoutGroup));
}

async function updateReadoutGroup(readoutGroup: SavedReadoutGroup) {
    return save(() => readoutGroupsAPI.bySchemaConfig(schemaConfig.id).update(readoutGroup));
}
async function save(saveFn: any) {
    return withLoadingScreen(async () => {
        await saveFn();
        emit("saved");
    });
}
async function deleteReadoutGroup(readoutGroup: SavedReadoutGroup) {
    return withLoadingScreen(async () => {
        await readoutGroupsAPI.bySchemaConfig(schemaConfig.id).delete(readoutGroup.id);
        emit("deleted");
    });
}

</script>
